import { MessageCircle, Phone } from "lucide-react";
import { SITE } from "@/lib/site";

export default function FloatingActions() {
  const waLink = `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(
    "Hello Dr. Anita, I'd like to know more about your treatments."
  )}`;

  return (
    <div className="fixed right-5 bottom-5 z-40 flex flex-col gap-3" data-testid="floating-actions">
      <a
        href={waLink}
        target="_blank"
        rel="noreferrer"
        className="pulse-ring w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg hover:scale-105 transition"
        aria-label="Chat on WhatsApp"
        data-testid="floating-whatsapp"
      >
        <MessageCircle size={26} />
      </a>
      <a
        href={`tel:${SITE.phone}`}
        className="w-14 h-14 rounded-full bg-[color:var(--na-teal)] text-white flex items-center justify-center shadow-lg hover:bg-[color:var(--na-maroon)] transition"
        aria-label="Call clinic"
        data-testid="floating-call"
      >
        <Phone size={22} />
      </a>
    </div>
  );
}
